module.exports = __webpack_public_path__ + "static/media/dice-d10.8b5e44a9.svg";